
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLogoPreloader } from '@/hooks/useLogoPreloader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  
  // Trigger logo preloading as early as possible
  useLogoPreloader();

  // Prepare for showing the protected content
  useEffect(() => {
    if (!isLoading && user) {
      // Preload logos when we know we'll be showing the protected content
      const logoUrls = [
        "/lovable-uploads/c5290104-a025-440a-87a0-1157af3806ed.png",
      ];
      
      logoUrls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    }
  }, [isLoading, user]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-2">Loading...</h2>
          <p className="text-muted-foreground">Please wait while we verify your authentication.</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
